module.exports = __webpack_public_path__ + "img/clement-horse2-min.de8cec57.png";